import { useEffect, useSyncExternalStore } from "react";
import { useRouter } from "next/router";
import { SpeedInsights } from "@vercel/speed-insights/next";
import { isThankYouPage } from "lib/analytics-privacy";
import PrivacyConsent from "./privacy-consent";
import { subscribeTracking, getTrackingSnapshot, getServerSnapshot, saveConsent,
  trackPage, pauseTracking, sanitizePerformanceEvent } from "lib/tracking-client";

export default function Tracking() {
  const router = useRouter();
  const snapshot = useSyncExternalStore(subscribeTracking, getTrackingSnapshot, getServerSnapshot);
  const locale = router.locale || "en";
  const allowedRoute = !["/404", "/500", "/_error"].includes(router.pathname) && !isThankYouPage(router.asPath);

  useEffect(() => {
    if (!snapshot.ready || !router.isReady) return;
    trackPage(router.asPath, locale, allowedRoute);
    const cancelled = () => trackPage(router.asPath, locale, allowedRoute);
    router.events.on("routeChangeStart", pauseTracking);
    router.events.on("routeChangeError", cancelled);
    return () => {
      router.events.off("routeChangeStart", pauseTracking);
      router.events.off("routeChangeError", cancelled);
    };
  }, [router.asPath, router.events, router.isReady, locale, allowedRoute, snapshot.ready]);

  return <>
    <PrivacyConsent ready={snapshot.ready} consent={snapshot.consent} locale={locale} onSave={saveConsent} />
    {snapshot.ready && snapshot.consent?.analytics && allowedRoute && process.env.NEXT_PUBLIC_VERCEL_ENV === "production" &&
      <SpeedInsights beforeSend={event => sanitizePerformanceEvent(event, router.pathname)} />}
  </>;
}
